import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// import SystemDashboard from 'layouts/SystemDashboard';
// import {
//   getAllItems,
//   deleteItem,
//   // getItem,
//   // saveItem,
//   // updateItem,
// } from './ItemService';

import { getAllAppsByProduct, removeAppFromProduct } from './ProductService';
// import { getSection } from '../Sections/SectionService';
import AttachApp from './AttachApp';
import {
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // Box,
  // Breadcrumbs,
  // Link,
} from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { useTheme } from '@mui/material/styles';
import { alpha, useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Container from 'components/Container';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const ProductAppList = (): JSX.Element => {
  const theme = useTheme();
  const [items, setItems] = useState<any[]>([]);
  const { productid } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // State variable to track loading state

  const [openDialog, setOpenDialog] = useState(false);
  const [appIdToDelete, setAppIdToDelete] = useState(null);

  // useEffect(() => {
  //   listItemChildren();
  // }, [parentId, sectionId]);

  useEffect(() => {
    listProductApps();
  }, []);

  function listProductApps() {
    setLoading(true); // Set loading to true when starting the request
    getAllAppsByProduct(productid)
      .then((response) => {
        setItems(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      })
      .finally(() => {
        setLoading(false); // Set loading to false when the request is completed (whether successful or not)
      });
  }

  function selectApp(appid) {
    console.log(appid);
    navigate(`/system/dashboard/section/1/item/${appid}`);
  }

  const handleDeleteConfirmation = (appid) => {
    setAppIdToDelete(appid);
    setOpenDialog(true);
  };

  const handleDeleteItem = () => {
    // Call your removeItem function to delete the item
    removeApp(productid, appIdToDelete);
    // Close the dialog
    setOpenDialog(false);
  };

  function removeApp(productid, appid) {
    removeAppFromProduct(productid, appid)
      .then(() => {
        // Item deleted successfully, update the list
        listProductApps();
      })
      .catch((error) => {
        // Handle errors or exceptions
        if (error.response) {
          // The request was made and the server responded with a status code
          // Display an error message based on the response status
          console.error(
            'Request failed with status code:',
            error.response.status,
          );
          // Check if the error is due to a foreign key constraint violation
          if (
            error.response.status === 400 &&
            error.response.data.includes('foreign key constraint')
          ) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete the item because it is referenced by other records.',
            );
          }
          if (error.response.status === 401) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete or update a parent row: a foreign key constraint fails.',
            );
          } else {
            // Display a generic error message for other types of errors
            notify(
              'An error occurred while deleting the item. Please try again later.',
            );
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error(
            'Request made but no response received:',
            error.request,
          );
        } else {
          // Something happened in setting up the request that triggered an error
          console.error('Error setting up the request:', error.message);
        }
      });
  }

  return (
    <Container>
      <Typography variant="h4">
        Make this product available for the following apps
      </Typography>
      {loading && <p>Loading...</p>}
      <AttachApp listProductApps={listProductApps} />
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: 'alternate.main' }}>
            <TableRow>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  ID
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  App Name
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Version Number
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Status
                </Typography>
              </TableCell>
              <TableCell />
              <TableCell />
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
              <DialogTitle>Confirm Deletion</DialogTitle>
              <DialogContent>
                Are you sure you want to remove this app?
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                <Button onClick={handleDeleteItem} autoFocus>
                  Remove
                </Button>
              </DialogActions>
            </Dialog>
            {items.map((item, i) => (
              <TableRow
                key={i}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                onClick={() => selectApp(item.id)}
              >
                <TableCell component="th" scope="row">
                  <ListItem sx={{ p: 0, m: 0 }}>
                    <ListItemAvatar>{/* <Avatar src={} /> */}</ListItemAvatar>
                    <ListItemText primary={item.id} secondary={item.id} />
                  </ListItem>
                </TableCell>
                <TableCell>
                  <Typography>{item.appName}</Typography>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.appName}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    variant={'caption'}
                    fontWeight={700}
                    sx={{
                      bgcolor: alpha(theme.palette.success.light, 0.1),
                      color: theme.palette.success.dark,
                      paddingX: 1.5,
                      paddingY: 0.5,
                      borderRadius: 4,
                      display: 'inline',
                    }}
                  >
                    {item.versionNumber}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.buildNumber}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.status}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'primary'}
                    variant={'subtitle2'}
                    fontWeight={700}
                    sx={{ cursor: 'pointer' }}
                  >
                    Edit
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'primary'}
                    variant={'subtitle2'}
                    fontWeight={700}
                    sx={{ cursor: 'pointer' }}
                  >
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation(); // Stop the click event from propagating
                        handleDeleteConfirmation(item.id); // Show confirmation dialog before deleting
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default ProductAppList;
